// extracted by mini-css-extract-plugin
export var excerpt = "blog-index-module--excerpt--uK7ol";
export var paginate = "blog-index-module--paginate--O4YxY";
export var postDate = "blog-index-module--postDate--BojVO";
export var postItem = "blog-index-module--postItem--XnVqD";
export var postTitle = "blog-index-module--postTitle--lpeZJ";
export var titleLink = "blog-index-module--titleLink--3I9C5";